/**
 * Scroll-reveal directive: fades/slides elements in when they enter the viewport.
 * Usage: v-reveal  |  v-reveal="'fade'"  |  v-reveal="{ delay: 120 }"
 */
const DEFAULTS = {
  threshold: 0.12,
  rootMargin: "0px 0px -8% 0px",
};

function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

function normalizeBinding(binding) {
  if (!binding.value) return { variant: "up", delay: 0 };
  if (typeof binding.value === "string") {
    return { variant: binding.value, delay: 0 };
  }
  return {
    variant: binding.value.variant || "up",
    delay: Number(binding.value.delay) || 0,
  };
}

export const reveal = {
  mounted(el, binding) {
    const { variant, delay } = normalizeBinding(binding);
    el.classList.add("bh-scroll");
    el.classList.add(`bh-scroll--${variant}`);
    if (delay) {
      el.style.setProperty("--bh-reveal-delay", `${delay}ms`);
    }

    if (prefersReducedMotion()) {
      el.classList.add("is-visible");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: DEFAULTS.threshold,
        rootMargin: DEFAULTS.rootMargin,
      }
    );

    el.__bhRevealObserver = observer;
    observer.observe(el);
  },
  unmounted(el) {
    if (el.__bhRevealObserver) {
      el.__bhRevealObserver.disconnect();
      delete el.__bhRevealObserver;
    }
  },
};

export default reveal;
